import type { HTMLAttributes } from "react";
import type {
  FormControlProps,
  FormFieldProps,
  FormLabelProps,
  FormMessageProps,
  FormProps,
} from "@radix-ui/react-form";
import { Control, Field, Label, Message, Root } from "@radix-ui/react-form";
import { cn } from "@acdc2/ui/lib/utils";

type FormFieldsetProps = {
  className?: string;
  children: React.ReactNode;
};

type FormLegendProps = {
  className?: string;
  children: React.ReactNode;
};

export function Form(props: FormProps) {
  return <Root {...props} />;
}

export function FormField({ className, ...props }: FormFieldProps) {
  return (
    <Field className={cn("group flex flex-col gap-2", className)} {...props} />
  );
}

export function FormLabel({ className, ...props }: FormLabelProps) {
  return (
    <Label
      className={cn("group-data-[invalid=true]:text-destructive", className)}
      {...props}
    />
  );
}

export function FormControl(props: FormControlProps) {
  return <Control {...props} />;
}

export function FormMessage({ className, ...props }: FormMessageProps) {
  return (
    <Message
      className={cn("text-[0.8rem] font-medium text-destructive", className)}
      {...props}
    />
  );
}

export function FormHelpText({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return (
    <p
      className={cn("text-[0.8rem] text-muted-foreground", className)}
      {...props}
    />
  );
}

export function FormFieldset({ className, ...props }: FormFieldsetProps) {
  return (
    <fieldset className={cn("flex flex-col gap-2", className)} {...props} />
  );
}

export function FormLegend({ className, ...props }: FormLegendProps) {
  return (
    <legend
      className={cn(
        "contents group-data-[invalid=true]:text-destructive",
        className,
      )}
      {...props}
    />
  );
}
